module.exports = __webpack_public_path__ + "static/WEDDING E&M-69-0c2532b45f185af7eeb010e715cafacb.jpg";